import CarriersConstants from '../../carriers/constants';

export const PATH = `${CarriersConstants.PATH}/branches`;
export const PAGE_TITLE = 'GestaoFilial';
export const PAGE_SIZE = 10;
